/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext } from "react";
import { graphql } from "gatsby";
import { DocumentContext } from "~context/DocumentContext";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import ProductGrid from "~components/ProductGrid";
import SEO from "~components/SEO";
import { parseProducts } from "~utils/shopify";

const ProductsPage = ({ data, location }) => {
  const { device } = useContext(DocumentContext);

  const { frontmatter } = data.markdownRemark;

  const products = parseProducts(data);

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="products-page w-full relative">
        <section className="w-full relative block pt-20 xs:pt-12">
          <div className="grid pt-20">
            <article className="grid-end-6 sm:grid-end-9 xs:grid-end-12">
              <h1
                className={`animation-appear-down-slow animation-delay-2 ${
                  device === `desktop` ? `f1` : `f2`
                }`}
              >
                Shop All Products
              </h1>

              <p className="animation-appear-down-slow animation-delay-3 mt-6 b1">
                Elevate your daily green tea experience with our beautifully
                curated selection of tea and teawares.
              </p>
            </article>
          </div>
        </section>

        <div className="animation-appear-down-slow animation-delay-5">
          <ProductGrid compact noborder products={products} />
        </div>
      </Layout>

      <Footer />
    </>
  );
};

export default ProductsPage;

export const query = graphql`
  query ProductsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "product-page" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            shopifyHandle
            priority
          }
        }
      }
    }
    allShopifyProduct {
      edges {
        node {
          id
          title
          description
          handle
          images {
            originalSrc
          }
          productType
          vendor
          variants {
            id
            sku
            title
            image {
              originalSrc
            }
            price
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
    allShopifyAdminProduct {
      edges {
        node {
          products {
            handle
            variants {
              alternative_id
              title
            }
          }
        }
      }
    }
  }
`;
